import FiltrosFacturas from '../../moleculas/FiltrosFacturas/FiltrosFacturas'

function FiltrosFacturasContainer() {
  return (
    <div className="flex flex-row justify-around m-3">
      <FiltrosFacturas/>      

  </div> 
  )
}

export default FiltrosFacturasContainer